import type { MouseEvent } from 'react';

interface BtnProps {
  label: string;
  actionClick: (e: MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}
export function BtnPrimary({ label, actionClick, className = '' }: BtnProps) {
  const handlerClickModal = (e: MouseEvent<HTMLButtonElement>) => {
    actionClick && actionClick(e);
  };
  return (
    <button
      onClick={handlerClickModal}
      className={`
co-bg-primary-500 co-font-semibold co-text-white co-px-4 co-py-[12px] co-rounded-full hover:co-bg-blue-700 focus:co-outline-none focus:co-ring focus:co-ring-blue-300 active:co-bg-blue-800
${className}`}
    >
      {label}
    </button>
  );
}

export function BtnPrimaryOutlined({
  label,
  actionClick,
  className = ''
}: BtnProps) {
  const handlerClickModal = (e: MouseEvent<HTMLButtonElement>) => {
    actionClick && actionClick(e);
  };
  return (
    <button
      onClick={handlerClickModal}
      className={`
            co-bg-white co-font-semibold co-border co-border-[#006DFF] co-text-primary-500 co-px-4 co-py-[12px] co-rounded-full hover:co-bg-blue-50 focus:co-outline-none focus:co-ring focus:co-ring-blue-300 active:co-bg-blue-100
            ${className}`}
    >
      {label}
    </button>
  );
}
